import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface DashboardResponse {
    new_enquiry: number;
    accept_enquiry: number;
    pending_client_offer: number;
    release_of_lien: number;
    Resolutions_accepted_pending_payment: number;
    pending_client_acceptance: number;
    accepted_pending_payment: number;
    pending_trust_funds: number;
    closed_archieved: number;
    closed_cases: number;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private apiUrl = `${environment.apiUrl}/api/dashboard`;

    constructor(private http: HttpClient) {}

    getDashboard(): Observable<DashboardResponse> {
        return this.http.get<DashboardResponse>(this.apiUrl);
    }

    getDashboardCasesData(type: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/api/dashboard_cases_data`, {
            params: { type }
        });
    }

    searchCases(search: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/api/dashboard-case-search`, {
            params: { search }
        });
    }
}
